class StarterSetForm extends HTMLElement {
  constructor() {
    super();

    this.formEl = document.querySelector('.product-form');
    this.bundleItemEls = this.formEl.querySelectorAll('.bundle-item');
    this.variantInput = this.formEl.querySelector('input[name="id"]');
    this.originalVariantId = this.variantInput?.value || '';
    this.originalProductId = this.variantInput?.getAttribute('data-productid') || '';
    this.data = this.getSubscriptionData();
    this.init();
  }

  getSubscriptionData() {
    try {
      const el = document.getElementById('starter-set-subscription-data');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      console.warn('Invalid starter-set-subscription-data JSON');
      return {};
    }
  }

  getIsSubscription() {
    return document.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
  }
  getIsAdditionalOption() {
    return document.querySelector('[data-purchase-option]:checked')?.value === 'onetime-additional';
  }

  updateMainVariantId() {
    if (!this.variantInput) return;

    const isSubscription = this.getIsSubscription();
    const isAdditionalOption = this.getIsAdditionalOption();
    const selectedColorBtn = document.querySelector('.color-btn.checked');
    const selectedColor = selectedColorBtn?.dataset.color;
    const original_product_variants = isAdditionalOption ? this.data.additional_variant?.variants || [] : this.data.original_product_variants || [];

    const variants = isSubscription ? this.data.duplicate_product?.variants || [] : original_product_variants;

    const originalVariantId = isAdditionalOption ? this.data.additional_variant?.variant_id : this.originalVariantId;
    const originalProductId = isAdditionalOption ? this.data.additional_variant?.product_id : this.originalProductId;

    let matchedVariant = null;
    if (selectedColor) {
      const selectedColorLower = selectedColor.toLowerCase();
      matchedVariant = variants.find((v) => v.option1?.toLowerCase() === selectedColorLower);
    }

    if (matchedVariant) {
      this.variantInput.value = matchedVariant.id;
      this.variantInput.setAttribute('data-productid', matchedVariant.product_id);
    } else {
      const defaultVariantId = isSubscription ? this.data.duplicate_product?.variant_id : originalVariantId;
      const defaultProductId = isSubscription ? this.data.duplicate_product?.product_id : originalProductId;

      this.variantInput.value = defaultVariantId;
      this.variantInput.setAttribute('data-productid', defaultProductId);
    }

    this.updateSelectedVariantAvailability();
  }

  updateSelectedVariantAvailability() {
    const activeColorBtn = document.querySelector('.color-btn.checked');
    if (!activeColorBtn) return;

    const selectedColor = activeColorBtn.dataset.color;
    const isSubscription = this.getIsSubscription();
    const isAdditionalOption = this.getIsAdditionalOption();
    const original_product_variants = isAdditionalOption ? this.data.additional_variant?.variants || [] : this.data.original_product_variants || [];
    const variants = isSubscription ? this.data.duplicate_product?.variants || [] : original_product_variants;

    const matchedVariant = variants.find((v) => v.option1?.toLowerCase() === selectedColor?.toLowerCase());

    const oneTimePrice = isAdditionalOption ? document.querySelector('[data-onetime-additional-price]') : document.querySelector('[data-onetime-price]');

    const priceEl = isSubscription ? document.querySelector('[data-subscription-price]') : oneTimePrice;

    if (matchedVariant && priceEl) {
      const priceHTML =
        matchedVariant.compare_at_price > matchedVariant.price
          ? `<span class="price price--sale"><span>${this.formatMoney(matchedVariant.price)}</span><span><s>${this.formatMoney(matchedVariant.compare_at_price)}</s> </span> </span>`
          : `<span class="price">${this.formatMoney(matchedVariant.price)}</span>`;

      priceEl.innerHTML = priceHTML;
    }

    const submitBtn = this.formEl.querySelector('[data-bundle-submit]');
    const isMainVariantAvailable = matchedVariant && matchedVariant.available;
    const allBundleAvailable = (this.data.bundleItems || []).every((item) => item.available);

    if (!isMainVariantAvailable || !allBundleAvailable) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = window.variantStrings?.soldOut || 'Sold out';
    } else {
      submitBtn.removeAttribute('disabled');
      const priceText = this.formatMoney(matchedVariant.price);

      const baseText = window.variantStrings?.quickAdd || 'Add to cart';
      submitBtn.innerHTML = `${baseText} – <span>${priceText}</span>`;

      this.variantInput.value = matchedVariant.id;
      this.variantInput.setAttribute('data-productid', matchedVariant.product_id);
    }
  }

  formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.moneyFormat || '{{ amount }}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      // const centsAmount = parts[1] ? `${decimal}<sup class="cents">${parts[1]}</sup>` : '';
      const centsAmount = parts[1] ? `${decimal}${parts[1]}` : '';
      return number == 0 ? '0' + dollarsAmount + centsAmount : dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)?.[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      // 2026-10-23: SE/CH-Formate wie in global.js (SEK '{{amount_with_space_separator}} kr' -> '1 695,00 kr')
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Erzeugt eine kurze, so gut wie kollisionsfreie ID pro Add-to-Cart-Submission (2026-09-16,
  // Bugfix Starter-Set-Bundle-Merge: verhindert, dass zwei separat abgeschickte Sets (gleiche oder
  // unterschiedliche Varianten, Einmalkauf/Abo gemischt) im Cart-Drawer zu einer Karte verschmelzen.
  // bundle_root/bundle_attached_to bleiben unveraendert 'StarterSet' (wird von custom-cart-logic.js
  // per exaktem String-Vergleich erwartet) - _bundle_instance ist rein additiv fuer cart-drawer-v2.js.
  generateBundleInstanceId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  addProductsToCart() {
    const isSubscription = this.getIsSubscription();
    const isAdditionalOption = this.getIsAdditionalOption();
    const mainVariantId = this.variantInput.value;
    const bundleItemsArr = isAdditionalOption ? this.data.bundleItemsAdditional || [] : this.data.bundleItems || []
    const bundleInstanceId = this.generateBundleInstanceId();

    const mainItem = {
      id: mainVariantId,
      quantity: 1,
      properties: {
        bundle_root: 'StarterSet',
        _bundle_instance: bundleInstanceId,
        _bundle_additional_option: isAdditionalOption ? 'true' : '',
        // 2026-09-29 (Christian-Feedback): "Bearbeiten"-Stift im Cart-Drawer landete auf der PDP des
        // Pad-Bundle-Produkts (root.url in cart-drawer-v2.js) statt auf der echten Starter-Set-
        // Verkaufsseite, von der aus gekauft wurde -- das Pad-Bundle-Produkt selbst ist nur ein
        // internes Preis-/SKU-Vehikel (duplicate_product/additional_variant), keine echte PDP.
        // Aktuelle Seiten-URL beim Add-to-Cart als Property mitschicken, cart-drawer-v2.js nutzt sie
        // jetzt bevorzugt fuer den Bearbeiten-Link (siehe dortiger Kommentar, bundleEditUrl()).
        _pdp_url: window.location.pathname,
      },
    };

    const bundleItems = bundleItemsArr.map((mg) => {
      const item = {
        id: mg.variant_id,
        quantity: mg.quantity,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      };

      if (isSubscription) {
        item.selling_plan = mg.plan_id;
      }
      // else {
      //   item.properties._discount = '100%';
      // }

      return item;
    });

    const giftItems = (isSubscription && window.FGS_SETTINGS && window.FGS_SETTINGS.enabled && Array.isArray(window.FGS_SETTINGS.gifts))
      ? window.FGS_SETTINGS.gifts.map((g) => ({ id: g.id, quantity: 1, properties: g.properties }))
      : [];
    const cartItems = [...bundleItems, mainItem, ...giftItems];

    const submitBtn = this.formEl.querySelector('[data-bundle-submit]');
    // const spinner = submitBtn.querySelector('.loading-overlay__spinner');
    // const submitText = submitBtn.querySelector('span');

    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');
    // if (spinner) spinner.classList.remove('hidden');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject('Cart error')))
      .then(() => {
        window.SLIDECART_UPDATE?.();
        setTimeout(() => {
          // 2026-10-26: AMP deinstalliert, custom-cart-logic.js nicht mehr geladen (Logik lebt im Custom Side Cart)
          if (typeof window.handleCustomCartLogic === 'function') window.handleCustomCartLogic();
          window.SLIDECART_OPEN?.();
          document.body.classList.remove('scroll-lock-mobile');
        }, 300);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        // if (spinner) spinner.classList.add('hidden');
      });
  }

  setupPurchaseOptionListener() {
    const purchaseOptionsEl = document.querySelector('purchase-options');
    if (!purchaseOptionsEl) return;

    purchaseOptionsEl.addEventListener('change', (e) => {
      this.updateMainVariantId();
      this.updateSelectedVariantAvailability();
    });
  }

  init() {
    const submitBtn = this.formEl.querySelector('[data-bundle-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addProductsToCart();
      });
    }

    this.setupPurchaseOptionListener();
    this.updateMainVariantId();
    this.updateSelectedVariantAvailability();
  }
}

if (!window.customElements.get('purchase-options')) {
  window.customElements.define('purchase-options', StarterSetForm);
}
